<template>
	<div>
		<div class="unauth-form">
			<div class="unauth-form-container">
				<div class="unauth-form-elements">
					<sign-up-form v-model="form" :action="() => onSubmitSignup(form)"></sign-up-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import SignUpForm from './forms/SignUpForm';
import AuthMixin from '@/mixins/AuthMixin';

export default {

	name: 'SignUpPage',

	mixins: [ AuthMixin ],

	data() {
		return {
			form: {},
		};
	},

	methods: {

		async onSubmit() {
			await this.onSubmitSignup(this.form);

			this.$router.push('/dashboard');
		},

	},

	components: {
		SignUpForm,
	},

};

</script>
